<template>
  <Popup v-model="visible">
    <div class="biz-opt-in-store-popup">
      <div class="title">实际到店时间</div>
      <Picker
        :value="value"
        :data="pickerData"
        @on-change="onChange"
      />
      <button class="btn-primary" @click="handleSubmit">确认选择</button>
      <button class="btn-text" @click="visible = false">取消</button>
    </div>
  </Popup>
</template>

<script>
import { Popup, Picker } from '@lx-frontend/cvux'
import dayjs from 'dayjs'

const weekMap = {
  0: '周日',
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六'
}

const getNowValue = () => {
  return [
    `${dayjs().format('YYYY-MM-DD')} ${weekMap[dayjs().day()]}`,
    dayjs().format('HH'),
    dayjs().format('mm')
  ]
}

export default {
  props: {
    changeStatus: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    Popup,
    Picker
  },
  data() {
    return {
      visible: false,
      value: getNowValue(),
      loading: false
    }
  },
  computed: {
    pickerData() {
      const _dateValue = this.value[0].split(' ')[0]
      const now = dayjs()
      const startDate = dayjs().subtract(1, 'month')

      const len = dayjs().diff(startDate, 'day') + 1

      const dates = Array.from({ length: len }).map((_, index) => {
        const current = dayjs(startDate).add(index, 'day')
        return `${current.format('YYYY-MM-DD')} ${weekMap[current.day()]}`
      })

      const hoursMode = _dateValue === now.format('YYYY-MM-DD')
        ? 'before'
        : _dateValue === startDate.format('YYYY-MM-DD')
          ? 'after'
          : 'all'

      const startHour = hoursMode === 'after' ? now.hour() : 0
      const endHour = hoursMode === 'before' ? now.hour() : 23

      const hours = Array.from({ length: endHour - startHour + 1 }).map((_, index) => String(index + startHour).padStart(2, '0'))

      const _hourValue = Number(this.value[1])
      const minutesMode = hoursMode === 'after' && _hourValue === now.hour()
        ? 'after'
        : hoursMode === 'before' && _hourValue === now.hour()
          ? 'before'
          : 'all'

      const startMinute = minutesMode === 'after' ? now.minute() : 0
      const endMinute = minutesMode === 'before' ? now.minute() : 59

      const minutes = Array.from({ length: endMinute - startMinute + 1 }).map((_, index) => String(index + startMinute).padStart(2, '0'))

      return [
        dates,
        hours,
        minutes
      ]
    }
  },
  methods: {
    open() {
      this.visible = true
      this.value = getNowValue()
    },
    onChange(value) {
      let [_date, hour, minute] = value
      const date = _date.split(' ')[0]
      const now = dayjs()
      const startDate = dayjs().subtract(1, 'month')

      const padZero = (num) => num.toString().padStart(2, '0')

      // 处理边界
      if (date === now.format('YYYY-MM-DD')) {
        if (Number(hour) > now.hour()) hour = padZero(now.hour())
        if (Number(hour) === now.hour() && Number(minute) > now.minute()) minute = padZero(now.minute())
      } else if (date === startDate.format('YYYY-MM-DD')) {
        if (Number(hour) < startDate.hour()) hour = padZero(startDate.hour())
        if (Number(hour) === startDate.hour() && Number(minute) < startDate.minute()) minute = padZero(startDate.minute())
      }
      this.value = [_date, hour, minute]
    },
    async handleSubmit() {
      if (this.loading) return
      this.loading = true
      try {
        const [_date, hour, minute] = this.value
        const date = _date.split(' ')[0]
        await this.changeStatus({
          action: 'fulfill',
          fulfilled_at: dayjs(`${date} ${hour}:${minute}`).format('YYYY-MM-DD HH:mm:ss')
        })
        this.visible = false
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="less">
@w2: 75rem;

::v-deep {
  &.vux-popup-dialog {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: #F1F5F8;
  }
}

.biz-opt-in-store-popup {
  padding: 30/@w2;

  .title {
    font-size: 32/@w2;
    color: #1F2023;
    padding: 20/@w2 0;
  }

  .btn-text {
    color: #979797;
    background: transparent;
    width: 100%;
    height: 80/@w2;
    line-height: 80/@w2;
    border-radius: 8/@w2;
    border: none;
    margin-top: 20/@w2;
    font-size: 28/@w2;
  }

  .btn-primary {
    background-color: #0078FD;
    color: #fff;
    width: 100%;
    height: 80/@w2;
    line-height: 80/@w2;
    border-radius: 8/@w2;
    border: none;
    margin-top: 20/@w2;
    font-size: 28/@w2;
  }

  ::v-deep {
    .scroller-mask {
      background-image:
        linear-gradient(to bottom, rgba(241, 245, 248, .95), rgba(241, 245, 248, .6)),
        linear-gradient(to top, rgba(241, 245, 248, .95), rgba(241, 245, 248, .6));
    }

    .vux-flexbox {
      .vux-flexbox-item {
        &:first-child {
          flex: 2;
        }
      }
    }
  }
}
</style>
